const themeDomain = sendToJs.theme_domain;

// To wrap the text between asterisks (*) in a <span> using JavaScript, you can use a regular expression to find the text 
// between asterisks and then replace it with the text wrapped in a <span> element.
export const ilHighlightText = (text) => {
    // Regular expression to find text between asterisks
    const regex = /\*(.*?)\*/g;

    // Replace the text between asterisks with the same text wrapped in a <span>
    const replacedText = text.replace(regex, '<span class="high-point">$1</span>');

    return replacedText;
}

export const ilStripHtmlTags = (html) => {
    // Create a new div element
    let doc = new DOMParser().parseFromString(html, 'text/html');
    // Return the text content of the element, which would strip any HTML tags
    return doc.body.textContent || "";
}

/**
 * Return a specified number of characters from a given text.
 *
 * @param {string} text The input text.
 * @param {number} length The desired length of the output text.
 * @returns {string} The truncated text.
 */
export const ilGetText = (text, length = 58) => {
    if (text.length <= length) {
        return text;
    }

    // Strip HTML tags and then truncate the text
    let strippedText = text.replace(/<[^>]+>/g, ''); // Remove HTML tags
    let truncatedText = strippedText.substring(0, length).trim(); // Truncate to desired length

    return truncatedText + '...';
}

export const ilReplaceDynamicPlaceholders = (text = '') => {
    if (!text) {
        return '';
    }

    const currentYear = String(new Date().getFullYear());
    const siteTitle = sendToJs?.site_title || '';

    return text
        .replace(/\[year\]/gi, currentYear)
        .replace(/\[site_title\]/gi, siteTitle);
};


/**
 * Helper function to convert backslash \ to <br>
 * Example: "Line 1\line 2" => "Line 1<br>line 2"
 *
 * @param {string} title - The input string.
 * @returns {string} - The string with backslashes replaced by <br>.
 */
export const ilLineToBreak = (title = '') => {
    return title ? title.replace(/\\n|\\|\r\n|\r|\n/g, '<br />') : '';
};

/**
 * Wraps text between pipes (|) with a <span> tag.
 * Example: "Hello I'm a |span|" → "Hello I'm a <span class="your-class">span</span>"
 *
 * @param {string} title - The input string containing text within pipes.
 * @param {string} className - The optional CSS class to apply to the span.
 * @returns {string} - The transformed string with spans.
 */
export const ilLineToSpan = (title = '', className = 'il-highlight') => {
    if (!title) return '';
    const classAttr = className ? ` class="${className}"` : '';
    return title.replace(/\|(.+?)\|/g, `<span${classAttr}>$1</span>`);
}

/**
 * Wraps text between pipes (|) with a <span> tag, allowing for separate classes for light and bold spans.
 * 
 * @param {string} title - The input string containing text within pipes.
 * @param {string} lightClass - The optional CSS class to apply to the light span.
 * @param {string} boldClass - The optional CSS class to apply to the bold span.
 * @returns {string} - The transformed string with spans.
 */
export const ilFormatLine = (title = '', lightClass = 'il-list', boldClass = 'il-list-desc') => {
    if (!title) return '';
    const lightAttr = lightClass ? ` class="${lightClass}"` : '';
    const boldAttr = boldClass ? ` class="${boldClass}"` : '';
    return title
        .replace(/\|\|(.+?)\|\|/g, `<span${boldAttr}>$1</span>`)
        .replace(/\|(.+?)\|/g, `<span${lightAttr}>$1</span>`);
};

export const ilCreateList = (text = '', className = 'il-list') => {
    if (!text) {
        return null;
    }

    const rows = text
        .split(/\r?\n/)
        .map((row) => row.trim())
        .filter(Boolean);

    if (rows.length === 0) {
        return null;
    }

    return wp.element.createElement(
        'ul',
        { className },
        rows.map((row, index) => wp.element.createElement('li', { key: index }, row))
    );
};

export const ilTheIcon = (icon) => {
    if (!icon) return null;

    return '/wp-content/themes/'+themeDomain+'/src/icons/' + icon + '.svg';
}